import api from 'common/api'

import types from './types'

const fetchCounts = (highSchoolId) => {
  return (dispatch) => {
    dispatch({
      type: types.FETCH_COUNTS_START,
    })
    api
      .get(`/api/highschools/${highSchoolId}/visits/stats`)
      .then((result) => {
        dispatch({
          type: types.FETCH_COUNTS_SUCCESS,
          payload: {
            confirmed: result.ConfirmedCount,
            draft: result.DraftCount,
            open: result.OpenCount,
            pending: result.PendingRequestCount,
            meetingsBooked: result.FullMeetingCount,
            meetingsOpen: result.OpenMeetingCount,
          },
        })
      })
      .catch(() => {
        dispatch({
          type: types.FETCH_COUNTS_FAILURE,
        })
      })
  }
}

export default {
  fetchCounts,
}
